import React from 'react';
import { InstructionFormDetails } from '../../commonAfterFormPage/InstructionFormDetails';
import { NormalText } from '../../Styles';
import FrictionlessAfterFormSpecialComponent from './FrictionlessAfterFormSpecialComponent';
import config from '@app/config';

export const ChileLightFrictionFormDetails: InstructionFormDetails = {
  instructionsSubTitle: 'supplierValidation.afterRegister.chileLightFriction.nowYouAreRegistered',
  paymentInstructionsTitle: 'supplierValidation.afterRegister.paymentInst',
  paymentInstructionsLines: [
    {
      description: 'supplierValidation.afterRegister.beneficiaryName',
      value: 'nsKnox Technologies, Inc',
    },
    {
      description: 'supplierValidation.afterRegister.address',
      value: '135 Madison Ave, New York, NY 10016',
    },
    {
      description: 'supplierValidation.afterRegister.checkingAccount',
      value: '466007904549',
    },
    {
      description: 'supplierValidation.afterRegister.swift',
      value: 'supplierValidation.afterRegister.bofaWire.swiftValues',
    },
  ],
  paymentInstructionsAddress: {
    description: 'supplierValidation.afterRegister.bankAndAddress',
    value: (
      <NormalText>
        Bank of America,
        <br />
        222 Broadway,
        <br />
        New York, NY 10038
      </NormalText>
    ),
  },
  currencies: [],
  pleaseNote: {
    pleaseNoteItem: [
      'supplierValidation.afterRegister.chileLightFriction.pleaseNote',
      'supplierValidation.afterRegister.chileLightFriction.haveTroubleLocatingInfo',
    ],
    hideInvoice: true,
  },
  showWireTransferWarningBox: {
    achWireTransfer: false,
    swiftWireTransfer: false,
  },
  extraInstructions: null,
  specialComponent: (
    <FrictionlessAfterFormSpecialComponent
      step1={'supplierValidation.afterRegister.chileLightFriction.willTransfer'}
      step2={'supplierValidation.afterRegister.chileLightFriction.uponReceiving'}
      withFieldInstructions={false}
    />
  ),
  downloadLink: `${config.supplierValidationAttachmentsUrl}ChileLf/en/chile-lf.pdf`,
};
